module.exports = __webpack_public_path__ + "assets/images/3-0EtlDh_C.png";


//////////////////
// WEBPACK FOOTER
// ../assets/images/empty.png
// module id = 2170
// module chunks = 0